// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "../../shared/services/config.service";
var RolesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function RolesService(apiService, helperService, configService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.configService = configService;
        this.roleTypes = this.configService.availableRoleTypes;
    }
    /**
     * Create a new role
     *
     * @since 1.0.0
     *
     * @param role Role data
     * @returns Observable<any>
     */
    RolesService.prototype.create = function (role) {
        return this.apiService.apiCall("POST", "roles", role, undefined, undefined, undefined, "v2");
    };
    /**
     * Get roles list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    RolesService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "roles", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get an exportation file of all roles
     *
     * @since 1.0.0
     */
    RolesService.prototype.getExport = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "roles/export", {}, { responseType: "blob" }, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given roleId data from back-end
     *
     * @since 1.0.0
     *
     * @param roleId ID of the role to get
     */
    RolesService.prototype.get = function (roleId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "roles/" + roleId, undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update role with given roleId with given role data
     *
     * @since 1.0.0
     *
     * @param roleId ID of role to update
     * @param data New permission's data
     */
    RolesService.prototype.update = function (roleId, data) {
        return this.apiService.apiCall("PUT", "roles/" + roleId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Delete permanently a role
     *
     * @since 1.0.0
     *
     * @param roleId ID of the role
     */
    RolesService.prototype.delete = function (roleId) {
        return this.apiService.apiCall("DELETE", "roles/" + roleId, undefined, undefined, undefined, undefined, "v2");
    };
    RolesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RolesService_Factory() { return new RolesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.ConfigService)); }, token: RolesService, providedIn: "root" });
    return RolesService;
}());
export { RolesService };
